import {AfterViewInit, Component, Inject, OnChanges, OnInit, PLATFORM_ID} from '@angular/core';
import {UserRoles} from '../../enums/general-enums';
import {PAGES_AND_PATHS} from '../../constants/pages-and-paths';
import {FollowersHttpService} from 'src/app/services/http-services/followers/followers-http.service';
import {ProfileTabsEnums} from '../../enums/profile-enums';
import {ShareEntitiesEnums} from '../../enums/chat-enums';
import {ProfileHttpService} from '../../services/http-services/profile/profile-http.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ChatHttpService} from '../../services/http-services/chat/chat-http.service';
import {AuthenticationHelperService} from '../../services/helpers/authentication-helper.service';
import {ItemInterface} from '../../interfaces/item-interface';
import {ItemsHttpService} from '../../services/http-services/items/items-http.service';
import {ToastrService} from 'ngx-toastr';
import {Meta} from '@angular/platform-browser';
import {isPlatformBrowser} from '@angular/common';

declare interface Window {
  adsbygoogle: any[];
}

declare var adsbygoogle: any[];

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
})
export class MyProfileComponent implements OnInit, AfterViewInit {
  profileData: any;
  activeTab = ProfileTabsEnums.lysts;
  userId!: number;
  username: any;
  isAuthUserProfile = true;
  isConfirmUnfollowModalOpen = false;
  isShareProfileModalOpen = false;
  profileUrl = '';
  baseUrl = '';
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly ProfileTabsEnums = ProfileTabsEnums;
  protected readonly UserRoles = UserRoles;
  protected readonly ShareEntitiesEnums = ShareEntitiesEnums;

  constructor(private profileHttpService: ProfileHttpService,
              private router: Router,
              private followersHttpService: FollowersHttpService,
              private activatedRoute: ActivatedRoute,
              private chatHttpService: ChatHttpService,
              private itemsHttpService: ItemsHttpService,
              private toastService: ToastrService,
              public authHelperService: AuthenticationHelperService,
              private meta: Meta,
              @Inject(PLATFORM_ID) private platformId: string) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(res => {
      this.username = res.userId;
      this.isAuthUserProfile = this.username === this.authHelperService.getUserData?.username;
      if (isPlatformBrowser(this.platformId)) {
        this.profileUrl = window.location.href;
        this.baseUrl = window.location.origin;
      }
      if (this.isAuthUserProfile) {
        this.getAuthUserProfile();
      } else {
        this.getUserProfile();
      }
      this.getPublicUserProfile();
    });
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   try {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({});
    //   } catch (e) {
    //   }
    // }, 900);
  }

  getAuthUserProfile(): void {
    this.profileHttpService.getAuthUserProfile().then(res => {
      this.profileData = res.data;
      this.userId = res.data.id;
      this.authHelperService.setUserData(this.profileData);
    });
  }

  getUserProfile(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.profileHttpService.getUserProfile({username: this.username}).then(res => {
        this.profileData = res.data;
        this.userId = res.data.id;
      });
    }
  }

  getPublicUserProfile(): void {
    this.profileHttpService.getPublicUser({username: this.username}).then(res => {
      const publicProfileData = res.data;
      this.meta.updateTag({
        property: 'og:title',
        content: `${publicProfileData.name} (${publicProfileData.username}) - TheLysts`
      });
      this.meta.updateTag({
        property: 'og:description',
        content: `${publicProfileData.followers_count} Followers, ${publicProfileData.followings_count} Following, ${publicProfileData.lysts_count} Lysts by ${publicProfileData.name} - TheLysts`
      });
      this.meta.updateTag({
        property: 'og:image',
        content: publicProfileData.profile_photo_url !== null ? publicProfileData.profile_photo_url : 'assets/images/og-image.png'
      });
      this.meta.updateTag({
        property: 'og:url', content: this.router.url
      });
    });
  }

  goToChatWithUser(): void {
    if (this.profileData.existing_conversation_id_between_me_and_this_user) {
      this.router.navigate([PAGES_AND_PATHS.chat.pagePath, this.profileData.existing_conversation_id_between_me_and_this_user]);
    } else {
      this.chatHttpService.createConversationV2({participants: [this.userId], is_group: false}).then(res => {
        this.router.navigate([PAGES_AND_PATHS.chat.pagePath, res.id]);
      });
    }
  }

  followUnfollowUser(): void {
    if (!this.isAuthUserProfile) {
      this.followersHttpService.followUnfollowUser(this.userId).subscribe((response: any) => {
        this.isConfirmUnfollowModalOpen = false;
        this.profileData.am_i_following_this_user = !this.profileData.am_i_following_this_user;
        this.profileData.am_i_following_this_user ? this.profileData.followers_count++ : this.profileData.followers_count--;
      });
    }
  }

  toggleTrendingItemLike(item: ItemInterface): void {
    const foundedItemIndex = this.profileData.trending_items.findIndex((element: ItemInterface) => element.id === item.id);
    this.profileData.trending_items[foundedItemIndex].am_i_favorite_this_lyst_item = !item.am_i_favorite_this_lyst_item;
    (this.profileData.trending_items[foundedItemIndex].am_i_favorite_this_lyst_item)
      ? this.profileData.trending_items[foundedItemIndex].favorite_users_count++
      : this.profileData.trending_items[foundedItemIndex].favorite_users_count--;
    this.itemsHttpService.addItemToFavorites(item.id).then((res: any) => {
      this.toastService.success(res.message);
    });
  }

  toggleFavoriteProfile(): void {
    this.profileData.am_i_favorite_this_user = !this.profileData.am_i_favorite_this_user;
    this.profileHttpService.toggleProfileFavorite({userId: this.userId}).then(res => {});
  }
}
